// extracted by mini-css-extract-plugin
module.exports = {"item":"SideListItem_item__b9PvY","info":"SideListItem_info__1xDCF"};